import PickStatusModal from '@/components/modals/PickStatusModal';
import Panel from '@/components/panel/Panel';
import { Errors } from '@/enums/errors.enum';
import { StageType } from '@/enums/stageType.enum';
import { Successes } from '@/enums/successes.enum';
import { notificationsMixin } from '../notifications';

/**
 * Mixin zarządzania dokumentem
 */
export const documentManageMixin = {
  components: { Panel, PickStatusModal },
  mixins: [notificationsMixin],
  data() {
    return {
      showStatusPicker: false,
      statusPickerDocument: {},
      statusPickerDocumentId: null
    };
  },

  methods: {
    // @vuese
    // Otwiera modal wyboru statusu
    openStatusPicker(document) {
      this.getStatuses(document.procedure.templateId)
        .then(() => {
          this.showStatusPicker = true;
          this.statusPickerDocument = document;
          this.statusPickerDocumentId = document.documentId || document.id;
        })
        .catch(err => this.notifyError(Errors.STATUS_CANNOT_LIST));
    },

    // @vuese
    // Pobierz listę statusów
    getStatuses(templateId) {
      return this.$store.dispatch('status/list', {
        type: StageType.DOCUMENT,
        templateId,
        count: -1
      });
    },
    // @vuese
    // Zamyka modal wyboru statusu
    closeStatusPicker() {
      this.showStatusPicker = false;
    },

    // @vuese
    // Zapisuje status dokumentu
    saveStatus(data) {
      this.$store
        .dispatch('document/setStatus', data)
        .then(() => {
          this.statusPickerDocument.statusId = data.statusId;
          this.statusPickerDocument.status = this.$store.state.status.list.find(status => status.id === data.statusId);
          this.closeStatusPicker();
          this.notifySuccess(Successes.DOCUMENT_SET_STATUS);
          this.afterStatusSave(data);
        })
        .catch(err => this.notifyError(Errors.DOCUMENT_CANNOT_SET_STATUS));
    },

    // @vuese
    // Funkcja wywoływana po zmianie statusu
    afterStatusSave(data) {}
  }
};
